import {NgModule} from '@angular/core';
import {LeadPageEventService} from '@app/services/analytics/EDDL/events/lead-page-event.service';

@NgModule({
  providers: [
    LeadPageEventService
  ]
})
export class LeadPageEventModule {
  constructor(
    _leadPageEventBuilder: LeadPageEventService
  ) {
  }
}
